import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../store/database';
import { useState } from 'react';

const adminLinks = [
  { to: '/admin', label: 'admin.title', end: true },
  { to: '/admin/members', label: 'admin.members' },
  { to: '/admin/releases', label: 'admin.releases' },
  { to: '/admin/archive', label: 'admin.archive' },
  { to: '/admin/messages', label: 'admin.messages' },
  { to: '/admin/events', label: 'admin.events' },
  { to: '/admin/invites', label: 'admin.invites' },
  { to: '/admin/categories', label: 'admin.categories' },
  { to: '/admin/orders', label: 'Orders' },
  { to: '/admin/legal', label: 'admin.legal' },
  { to: '/admin/content', label: 'Content' },
  { to: '/admin/media', label: 'Media' },
  { to: '/admin/brand-assets', label: 'Brand Assets' },
  { to: '/admin/content-blocks', label: 'Content Blocks' },
  { to: '/admin/media-library', label: 'Media Library' },
  { to: '/admin/house', label: 'House State' },
  { to: '/admin/house-control', label: 'House Control' },
  { to: '/admin/notifications', label: 'Notifications' },
  { to: '/admin/metrics', label: 'Metrics' },
  { to: '/admin/product', label: 'Products' },
  { to: '/admin/analytics', label: 'Analytics' },
  { to: '/admin/launch', label: 'Launch Control' },
  { to: '/admin/audit', label: 'admin.audit' },
  { to: '/admin/health', label: 'admin.health' },
];

export default function AdminLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const logout = useStore(s => s.logout);
  const [sideOpen, setSideOpen] = useState(false);

  const navCls = (isActive: boolean) =>
    `block px-3 py-1.5 text-[11px] tracking-widest uppercase font-sans transition-colors ${isActive ? 'text-charcoal bg-charcoal/5' : 'text-charcoal/40 hover:text-charcoal/70'}`;

  return (
    <div className="min-h-dvh bg-ivory text-charcoal flex">
      {/* Sidebar - desktop */}
      <aside className="hidden lg:flex flex-col w-56 border-r border-charcoal/5 bg-ivory py-6 px-2 flex-shrink-0">
        <NavLink to="/house" className="font-serif text-lg tracking-widest-xl px-3 mb-6">AH</NavLink>
        <nav className="flex-1 space-y-0.5">
          {adminLinks.map(l => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => navCls(isActive)}>
              {t(l.label)}
            </NavLink>
          ))}
        </nav>
        <div className="space-y-2 px-3 pt-4 border-t border-charcoal/5">
          <NavLink to="/house" className="block text-[11px] tracking-widest uppercase font-sans text-charcoal/40 hover:text-charcoal">
            ← {t('nav.dashboard')}
          </NavLink>
          <button onClick={() => { logout(); navigate('/login'); }} className="text-[11px] tracking-widest uppercase font-sans text-charcoal/40 hover:text-charcoal">
            {t('nav.logout')}
          </button>
        </div>
      </aside>

      {/* Mobile header */}
      <div className="flex-1 flex flex-col">
        <header className="lg:hidden sticky top-0 z-50 bg-ivory/95 backdrop-blur-sm border-b border-charcoal/5">
          <div className="px-4 py-3 flex items-center justify-between">
            <NavLink to="/admin" className="font-serif text-lg tracking-widest-xl">AH Admin</NavLink>
            <button onClick={() => setSideOpen(!sideOpen)} className="p-2">
              <div className="space-y-1">
                <div className={`w-5 h-px bg-charcoal transition-transform ${sideOpen ? 'rotate-45 translate-y-[3px]' : ''}`} />
                <div className={`w-5 h-px bg-charcoal transition-opacity ${sideOpen ? 'opacity-0' : ''}`} />
                <div className={`w-5 h-px bg-charcoal transition-transform ${sideOpen ? '-rotate-45 -translate-y-[3px]' : ''}`} />
              </div>
            </button>
          </div>
          {sideOpen && (
            <div className="border-t border-charcoal/5 bg-ivory px-2 py-3 space-y-0.5">
              {adminLinks.map(l => (
                <NavLink key={l.to} to={l.to} end={l.end} onClick={() => setSideOpen(false)} className={({ isActive }) => navCls(isActive)}>
                  {t(l.label)}
                </NavLink>
              ))}
            </div>
          )}
        </header>

        <main className="flex-1 p-4 lg:p-8 max-w-5xl">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
